export default __webpack_public_path__ + "static/media/search-icon.8a7f7bdc.svg";